module.exports = __webpack_public_path__ + "static/media/elephantSound.d8c248a5.mp3";